import useCartStore from '@/stores/cartStore'
import { useEffect, useState } from 'react'

export const useCart = () => {
  const [isClient, setIsClient] = useState(false)

  // Get all store state and actions
  const store = useCartStore()

  // Track client-side mounting
  useEffect(() => {
    setIsClient(true)
  }, [])

  return {
    ...store,
    isClient,
    isHydrated: store._hasHydrated && isClient
  }
}
